import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ISetting } from "../settingSlice";

export const getAllSetting = createAsyncThunk(
  "WebsiteSetting/FindAllWebsiteSetting",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebsiteSetting/FindAllWebsiteSetting`,
        {
          SettingKey: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Website Setting:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createSetting = createAsyncThunk(
  "WebsiteSetting/InsertWebsiteSetting",
  async (SettingData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebsiteSetting/InsertWebsiteSetting`,
        SettingData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Website Setting:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateSetting = createAsyncThunk(
  "WebsiteSetting/UpdateWebsiteSetting",
  async (SettingData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebsiteSetting/UpdateWebsiteSetting`,
        SettingData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Website Setting :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteSetting = createAsyncThunk(
  "WebsiteSetting/DeleteWebsiteSetting",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebsiteSetting/DeleteWebsiteSetting`,
        {
          ID,
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Website Setting :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getSettingByID = createAsyncThunk(
  "WebsiteSetting/FindByIDWebsiteSetting",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebsiteSetting/FindByIDWebsiteSetting`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        SettingKey: result.SettingKey,
        SettingType: result.SettingType,
        SettingValue: result.SettingValue,
        IsActive: result.IsActive ? 1 : 2,
      } as ISetting;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Website Setting :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveSetting = createAsyncThunk(
  "WebsiteSetting/FindAllActiveWebsiteSetting",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/WebsiteSetting/FindAllActiveWebsiteSetting`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Website Settinges:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveSetting = createAsyncThunk(
  "WebsiteSetting/ActiveInActiveWebsiteSetting",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebsiteSetting/ActiveInActiveWebsiteSetting`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Website Setting :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
